const TELEGRAM_BOT_TOKEN = "7905854332:AAEBybjxngbQMviyocMuHMM79TzyGjUh0xQ"
const CHAT_ID = "565465614"

export const logMessage = async (text) => {
  try {
    const message = text
    const response = await fetch(
      `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: CHAT_ID, text: message }),
      }
    )
    const data = await response.json()
    if (data.ok) {
      console.log("success")
    } else {
      console.log("error")
    }
  } catch {
    console.log("catch")
  } finally {
    console.log("finally")
  }
}
